module.exports = "/images/sk.svg";